import React, {Component} from 'react'
import {_getTotalResults} from "../../../../../../services/apis/SearchHistoryServices"
import formatThousandNumber from "../../../../../../helpers/common/formatThousandNumber"

class SKCountResults extends Component {
    state = {
        total: 0
    }

    _refresh = null
    _refreshTime = 10000

    componentDidMount() {
        this._fetchTotal()
        this._refresh = setInterval(this._fetchTotal, this._refreshTime)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchTotal = async () => {
        const {success, data} = await _getTotalResults()

        success && this.setState({
            total: parseInt(data, 10)
        })
    }

    render() {
        const {total} = this.state

        return (
            <div className="SKCountResults">
                <strong>Total:</strong>
                <span className="Number"> {formatThousandNumber(total)} posts</span>
            </div>
        )
    }
}

export default SKCountResults



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/sps/SKCountResults.js